module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore,
      "close": _vm.onClose
    }
  }, [(_vm.value.length > 0) ? _c('list', {
    ref: "list",
    attrs: {
      "loadNextPage": _vm.loadNext,
      "clear": _vm.clear
    }
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.searchOnce && _vm.bookshelf.length === 0) ? _c('div', {
    staticClass: "notFound"
  }, [_vm._v("没有找到相关内容")]) : _vm._l((_vm.bookshelf), function(item, index) {
    return _c('movie-cover', {
      key: index,
      attrs: {
        "value": item,
        "event": "selected"
      },
      on: {
        "selected": _vm.onSelected
      }
    })
  })], 2)]) : _c('div', {
    staticClass: "history"
  }, _vm._l((_vm.history), function(item, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onSearch(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "input fixedTop"
  }, [_c('div', [_c('i', {
    staticClass: "icon icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-clear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onClearText
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7a567a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/search/index.vue
// module id = 345
// module chunks = 0